// src/pages/CategoriesPage.jsx
import { Link } from "react-router-dom";
import "../styles/categories-page.css";
import TerminalMessage from "../components/decor/TerminalMessage";

const categories = [
  {
    id: "esotericism",
    title: "Esotericism",
    description:
      "Symbolism, occult systems, ritual, metaphysics, mysticism, secrecy, hidden structures of meaning.",
  },
  {
    id: "cybernetics",
    title: "Cybernetics",
    description:
      "Systems, control, feedback, machines, interfaces, networks, technological culture.",
  },
  {
    id: "politics",
    title: "Politics",
    description:
      "Economics, ideology, labor, power, social order, class, historical change.",
  },
  {
    id: "medieval",
    title: "Medieval",
    description:
      "Premodern institutions, feudal structures, theology, sovereignty, medieval life.",
  },
  {
    id: "literature",
    title: "Literature",
    description:
      "Fiction, criticism, poetics, narrative structure, style, literary theory.",
  },
  {
    id: "music",
    title: "Music",
    description:
      "Sound, genre, criticism, atmosphere, musical history, sonic identity.",
  },
  {
    id: "projects",
    title: "Projects",
    description:
      "Build logs, experiments, prototypes, creative systems, ongoing constructions.",
  },
];

const CategoriesPage = () => {
  return (
    <div className="categories-page">
      <img
        src="/images/corner-piece.png"
        alt=""
        className="categories-page__corner categories-page__corner--top-left"
      />
      <img
        src="/images/corner-piece.png"
        alt=""
        className="categories-page__corner categories-page__corner--top-right"
      />
      <img
        src="/images/corner-piece.png"
        alt=""
        className="categories-page__corner categories-page__corner--bottom-left"
      />
      <img
        src="/images/corner-piece.png"
        alt=""
        className="categories-page__corner categories-page__corner--bottom-right"
      />
      <div className="categories-page__inner">
        <header className="categories-page__header">
          <span className="categories-page__eyebrow">Archive Taxonomy</span>
          <h1>Categories</h1>
          <p>Browse the seven primary domains of the archive.</p>
        </header>
          <TerminalMessage
          lines={[
            "Hello",
            "My name is Han-Tyumi",
            "I am a cyborg",
            "Born",
            "If you may call it that",
            "In a world that is dense and black",
            "Created without a desire to draw breath",
            "Without a desire to have being",
            "Without a yearning of just to be",
            "I'd like my desire back",
            "My life back",
            "My soul back",
            "My humanity.",
          ]}
        />
        <section className="categories-page__grid">
          {categories.map((category) => (
            <Link
              key={category.id}
              to={`/category/${category.id}`}
              className="categories-page__card"
            >
              <h2>{category.title}</h2>
              <p>{category.description}</p>
            </Link>
          ))}
        </section>
      </div>
    </div>
  );
};

export default CategoriesPage;